import "./single.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import List from "../../components/table/Table";
import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { db } from '../../firebase'
import { collection, getDocs, where, query, doc, getDoc } from "firebase/firestore";
import { AuthContext } from "../../context/AuthContext";
import VigilanteBarChart from '../../components/chart/VigilanteBarChart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { useSidebarState } from "../../components/sidebar/SidebarStateContext";
import { uploadErrorLogToFirestore } from "../../utils/logUtils";


/**
 * Componente para mostrar información detallada de un vigilante de seguridad.
 *
 * @returns {JSX.Element} - Componente Single.
 */
const Single = () => {

  const [vigilante, setVigilante] = useState([]);
  const { id } = useParams();
  const { currentUser, currentService } = useContext(AuthContext);
  const { collapsed } = useSidebarState();

  // Agregar una clase basada en el estado de colapso
  const containerClass = collapsed ? "singleContainer collapsed" : "singleContainer";

  // Debug: mostrar el ID que se está recibiendo
  console.log('ID recibido de useParams:', id);
  console.log('Tipo de ID:', typeof id);
  console.log('URL completa:', window.location.href);

  /**
    * Recupera el documento del usuario (vigilante) usando su id y el servicio actual.
    *
    * Ahora, usando currentService.id, accedemos directamente al documento del vigilante en la subcolección 'vigilantes' del servicio seleccionado.
    */
  const fetchUserDocuments = async () => {
    try {
      if (!currentService?.id) {
        console.error("No hay servicio seleccionado.");
        return;
      }
      // Accede directamente al documento del vigilante en el servicio actual
      const vigilanteRef = doc(db, 'servicios', currentService.id, 'vigilantes', id);
      const vigilanteSnap = await getDoc(vigilanteRef);
      if (vigilanteSnap.exists()) {
        setVigilante([{ id: vigilanteSnap.id, ...vigilanteSnap.data() }]);
        console.log('Vigilante encontrado:', { id: vigilanteSnap.id, ...vigilanteSnap.data() });
      } else {
        setVigilante([]);
        console.log('No se encontró el vigilante con ese id en el servicio actual.');
      }
    } catch (error) {
      uploadErrorLogToFirestore('Error al obtener los datos del vigilante:', error);
      console.error('Error al obtener los datos del vigilante:', error);
    }
  };

  useEffect(() => {
    fetchUserDocuments();
  }, [id]);

  return (
    <div className="single">
      <Sidebar />
      <div className={containerClass}>
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="item">
              {/* Verifica si hay una foto, si no, muestra el icono por defecto */}
              {vigilante?.[0]?.foto ?
                <img src={vigilante[0].foto} alt="Foto del vigilante" className="itemImg" /> :
                <AccountCircleIcon fontSize="inherit" />
              }
              <div className="details">
                <h2 className="itemTitle">{vigilante?.[0]?.nombre} {vigilante?.[0]?.apellidos}</h2>
                <p>ID: {vigilante?.[0]?.id}</p>
                <p>Email: {vigilante?.[0]?.correo}</p>
              </div>
            </div>
            <hr />
            {vigilante?.[0]?.tiendas && (
              <div className="detailItem">
                <span className="itemKey">Servicios: </span>
                <div className="tiendasContainer">
                  {vigilante[0].tiendas.map((tienda, index) => (
                    <div key={index} className="tiendaItem">
                      <span className="itemValue" key={index}>{tienda.numero}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="contactInfo">
              <PhoneIcon />
              {vigilante?.[0]?.telefono}
              <EmailIcon />
              {vigilante?.[0]?.correo}
            </div>
          </div>
          <div className="right">
            <VigilanteBarChart vigilante={vigilante?.[0]?.tipVS} />
          </div>
        </div>
        <div className="bottom">
          {vigilante?.[0]?.email && (
            <List email={vigilante[0].email} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Single;
